<template>
	<div class="project">
		<div class="bottomClass">
			<div class="uploadClass">
				<el-upload class="upload-demo" :action="http+'/zkep2/upload/upload'" :on-preview="handlePreview2" :on-remove="handleRemove2" :file-list="fileList" :data="personData" :on-change="onChange2" :before-upload="beforeUpload2" :show-file-list="false" accept=".xls,.xlsx">
					<button class="selectFile" slot="trigger" size="small" type="primary" id="fileName2">选择文件</button>
				</el-upload>
			</div>
			<div class="editButtonClass">
				<el-button type="primary" size="small" @click="exportClick2()">导出资产设置变比任务</el-button>
				<el-button type="primary" size="small" @click="importClick2()">导入关联设备</el-button>
			</div>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" v-loading="loading">
				<el-table-column prop="name" label="设备名称" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="设备类型" min-width="2%">
					<template slot-scope="scope">{{scope.row.type|typeFilter}}</template>
				</el-table-column>
				<el-table-column prop="model" label="设备型号" min-width="1%">
				</el-table-column>
				<el-table-column prop="gateway_name" label="阿里设备名称" min-width="2%">
				</el-table-column>
				<el-table-column prop="addr" label="通讯地址" min-width="1%">
				</el-table-column>
			</el-table>
		</div>

	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		//解决相同路由不刷新的问题
		watch: {
			$route(to, from) {
				/*当前年月*/
				var myDate = new Date();
				this.yearMonth = String(myDate.getFullYear()) + (myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1)
				if(this.$route.query.id) {
					this.project_id = this.$route.query.id
					this.getLink()
				}
				
			}
		},
		mounted() {
			/*当前年月*/
			var myDate = new Date();
			this.yearMonth = String(myDate.getFullYear()) + (myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1)
			this.project_id = this.$route.query.id
			if(this.project_id){
				this.getLink()
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				total: 0, //总条数
				project_id: '',
				yearMonth: '',
				personData: {}, //自定义上传参数
				fileList: [], //上传文件
				tableData: [],
				loading: false,
			}
		},
		filters: {
			typeFilter: function(val) {
				if(val == "1") {
					return "设备";
				}
				if(val == "2") {
					return "网关";
				}
			}
		},
		methods: {
			//加载的动画
			openFullScreen() {
				this.loadingAdd = this.$loading({
					lock: true,
					text: '',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0)'
				});
			},
			//列表
			getLink() {
				this.loading = true
				var params = {
					project_id: this.project_id
				}
				//console.log(params)
				let config = headers.headers('getLinkList')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/project/getLinkList', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading = false
					//console.log(res)
					if(res.data.length > 0) {
						this.tableData = res.data
					} else {
						this.tableData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//导入设备信息的点击
			importClick2() {
				document.getElementById("fileName2").click();
			},
			/*
			 * 上传
			 * */
			handleRemove2() {},
			onChange2() {},
			handlePreview2() {},
			beforeUpload2(file) {
				let fd = new FormData();
				fd.append('file', file); //传文件
				fd.append('path', '/mnt/xvdb/html/zkepA/storage/upload/' + this.yearMonth); //传其他参数
				var name = this.$uuid.v1()
				var index = file.name.lastIndexOf(".");
				var type = file.name.substring(index, file.name.length);
				fd.append('fileName', name + type); //传其他参数
				let config = headers.headers('uploadFile')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/upload/uploadFile',
					fd, {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res.data) {
						this.importDeviceFun(res.data);
					} else {}
				}).catch(err => {
					console.log(err)
				})
			},
			importDeviceFun(file) {
				let fd = new FormData();
				fd.append('file', file); //传文件
				fd.append('project_id', this.project_id); // 项目ID
				let config = headers.headers('importLink')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/project/importLink',
					fd, {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res) {
						location.reload()
					} 
				}).catch(err => {
					console.log(err)
				})
			},
			//导出资产设置变比任务
			exportClick2() {
				let config = headers.headers('exportAll')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					path: '/mnt/xvdb/html/zkepA/storage/excel/',
					project_id: this.project_id
				}
				//console.log(params)
				axios.get(this.http + '/zkep2/subproject/exportAll', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.openFullScreen()
					//console.log(res)
					if(res.data.res == '1') {
						setTimeout(() => {
							this.loadingAdd.close()
						}, 3000);
						var index = res.data.file.lastIndexOf("//");
						var fileName = res.data.file.substring(index + 2, res.data.file.length)

						//window.location.href = 'http://www.380v.top' + '/storage/excel/' + fileName
						/*防止下载txt文件直接打开而不是是下载*/
						/*注意：本地运行，还是会直接打开，部署到服务器就好啦！*/
//						let fileUrl = this.http.slice(0, -5) + '/zkepA/storage/excel/' + fileName;
						let fileUrl = 'http://www.380v.top' + '/storage/excel/' + fileName;
						let fileNameArray = fileUrl.split('/');
						let fileName = fileNameArray[fileNameArray.length - 1];
						let element = document.createElement('a');
						element.style.display = 'none';
						element.setAttribute('href', fileUrl);
						element.setAttribute('download', fileName);
						document.body.appendChild(element);
						element.click();
						document.body.removeChild(element);
					} else {
						res.msg = '导出失败'
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style>
	.project {
		height: 100%;
		padding: 1% 0 0 1%;
		position: relative;
		font-size: 13px;
		min-width: 700px;
		overflow: auto;
	}
	/*滚动条的样式*/
	
	::-webkit-scrollbar {
		width: 10px;
	}
	
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}
	
	::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
	.project .bottomClass {
		width: 100%;
		height: 60px;
		line-height: 60px;
		background-color: #fff;
		position: relative;
	}
	
	.project .editButtonClass {
		position: absolute;
		top: 0;
		right: 60px;
	}
	/*加载图标*/
	
	.el-loading-spinner {
		font-size: 46px;
	}
	
	.el-loading-spinner i {
		color: #34495e!important;
		opacity: 0.7;
	}
	
	.project .uploadClass {
		display: none;
	}
	
	.project .tableBox {
		margin-top: 20px;
		padding: 0 50px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
	}
	
	.project .el-table th {
		color: #000;
	}
	
	.project .el-table {
		font-size: 12px;
	}
	
	.project .el-table th,
	.project .el-table td,
	.project .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.project .el-table th {
		text-align: left;
		padding: 10px 0!important;
		font-weight: 400;
		color: #999;
	}
</style>


// WEBPACK FOOTER //
// src/components/Customer/Project.vue